import Card from "components/card";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { currentUser } from "services/users/authSlice";
import { ESService } from "services/esService";
import ApiList from "services/apiList";
import { IoIosArrowBack } from "react-icons/io";

const StudentsList = () => {
  const mount = useRef(true);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const location = useLocation();
  const [course, setCourse] = useState("");
  const columnsData = ["№", "Хэрэглэгчийн нэр", "Овог", "Нэр"];
  var user = useSelector(currentUser);

  useEffect(() => {
    if (mount.current) {
      mount.current = false;
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.courseStudentsUrl, "id=" + location.state.id).then(
        (json) => {
          if (json["status"]) {
            setTableData(json["data"]["students"]);
            setCourse(
              json["data"]["number"].toString() + json["data"]["group"]
            );
          }
        }
      );
    }
  }, [location.state, user]);

  return (
    <Card extra={"w-full h-full p-4  mt-4"}>
      <header className="mb-4 grid grid-cols-3 gap-4">
        <IoIosArrowBack
          onClick={() => {
            navigate("/admin/course");
          }}
          text="Буцах"
          className="h-8 w-8 cursor-pointer text-gray-600 hover:text-btn-1 dark:text-white "
        />
        <div className="relative flex  justify-center">
          <h1 className="line-clamp-1 overflow-hidden text-ellipsis text-xl font-bold capitalize hover:text-navy-700 dark:hover:text-white">
            {course} ангийн сурагчид
          </h1>
        </div>
        <span className=" h-8 w-8 "></span>
      </header>

      <div className="h-full overflow-x-scroll xl:overflow-hidden">
        <table className="responsive_table">
          <thead>
            <tr key={"s-header"}>
              {columnsData.map((column, index) => (
                <th key={"user-header" + index}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, i) => {
              return (
                <tr key={i}>
                  <td data-label="№">{i + 1}</td>
                  <td data-label="Хэрэглэгчийн нэр">
                    <button
                      onClick={() => {
                        navigate("/admin/user_edit/" + row.id);
                      }}
                      className="text-blue-800 underline hover:text-blue-600 dark:text-white "
                    >
                      {row.username}
                    </button>
                  </td>
                  <td data-label="Овог">{row.lastname}</td>
                  <td data-label="Нэр">{row.firstname}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Card>
  );
};

export default StudentsList;
